import React, { useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
} from "react-native";
import ManageAdmin from "../componentSuperadmin/manageAdmin";
import ManageApplications from "../componentSuperadmin/manageApplications";
import ManageAppChat from "../componentSuperadmin/manageAppChat"
import ManageAdvert from "../componentSuperadmin/manageAdvert";
import { useRecoilValue } from "recoil";
import { userState } from "../reducer";
import Chat from "../componentSuperadmin/chat";
import ManageUserAccount from "../componentSuperadmin/ManageUserAccount";
const { width, height } = Dimensions.get("window");

const homeSuperAdmin = ({ navigation }) => {
  const [page, setpage] = useState(1);
  const user = useRecoilValue(userState);

  return (
    <View style={styles.container}>
      <View
        style={{
          width: width,
          height: height * 0.1,
          backgroundColor: "#002377",
          alignItems: "center",
          justifyContent: "flex-end",
          flexDirection: "row",
        }}
      >
        <Text style={styles.TextProfile}>Super Admin</Text>
        <Image
          resizeMode={"center"}
          style={{
            width: 50,
            height: 50,
            marginHorizontal: 10,
            borderRadius: 30,
          }}
          source={{ uri: user.image_profile }}
        />
      </View>

      <View style={{ flexDirection: "row" }}>
        <View
          style={{
            width: width * 0.18,
            height: height * 0.9,
            backgroundColor: "#002377",
          }}
        >
          <TouchableOpacity
            onPress={() => setpage(1)}
            style={[
              styles.boxSection,
              { backgroundColor: page == 1 ? "#ffff" : "#002377" },
            ]}
          >
            <Text
              style={[
                styles.textSection,
                { color: page == 1 ? "#002377" : "#ffff" },
              ]}
            >
              จัดการผู้ดูแลระบบ
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => setpage(2)}
            style={[
              styles.boxSection,
              { backgroundColor: page == 2 ? "#ffff" : "#002377" },
            ]}
          >
            <Text
              style={[
                styles.textSection,
                { color: page == 2 ? "#002377" : "#ffff" },
              ]}
            >
              จัดการแอพพลิเคชั่น
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => setpage(3)}
            style={[
              styles.boxSection,
              { backgroundColor: page == 3 ? "#ffff" : "#002377" },
            ]}
          >
            <Text
              style={[
                styles.textSection,
                { color: page == 3 ? "#002377" : "#ffff" },
              ]}
            >
              โฆษณา
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => setpage(4)}
            style={[
              styles.boxSection,
              { backgroundColor: page == 4 ? "#ffff" : "#002377" },
            ]}
          >
            <Text
              style={[
                styles.textSection,
                { color: page == 4 ? "#002377" : "#ffff" },
              ]}
            >
              แชท
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => setpage(6)}
            style={[
              styles.boxSection,
              { backgroundColor: page == 6 ? "#ffff" : "#002377" },
            ]}
          >
            <Text
              style={[
                styles.textSection,
                { color: page == 6 ? "#002377" : "#ffff" },
              ]}
            >
              user account
            </Text>
          </TouchableOpacity>

          <View
            style={{
              width: width * 0.15,
              height: 10,
              justifyContent: "center",
              borderTopWidth: 1,
              alignSelf: "center",
              borderTopColor: "#ffff",
              marginTop: 16,
            }}
          ></View>

          <TouchableOpacity
            style={styles.boxSection}
            onPress={() => {
              navigation.navigate("Login");
            }}
          >
            <Text style={styles.textSection}>ออกจากระบบ</Text>
          </TouchableOpacity>
        </View>
        {page == 1 && <ManageAdmin navigation={navigation} />}
        {page == 2 && <ManageApplications navigation={navigation} />}
        {page == 3 && <ManageAdvert navigation={navigation} />}
        {page == 4 && <ManageAppChat navigation={navigation} setPage={() => setpage(5)} />}
        {page == 5 && <Chat navigation={navigation} />}
        {page == 6 && <ManageUserAccount navigation={navigation} />}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  textSection: {
    fontSize: 16,
    color: "#ffff",
    paddingLeft: 50,
    fontFamily: "Prompt-Regular",
  },
  boxSection: {
    width: width * 0.18,
    height: height * 0.055,
    justifyContent: "center",
  },
  TextProfile: {
    fontSize: 18,
    color: "#ffff",
    fontFamily: "Prompt-Regular"
  },
});
export default homeSuperAdmin;
